// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"fa483181","501":"fe0870f1"}[chunkId] + ".chunk.js";
};